export const translate = (x: number, y: number) => `translate(${x},${y})`;
export const translateX = (x: number) => translate(x, 0);
export const translateY = (y: number) => translate(0, y);


// WEBPACK FOOTER //
// ./src/d3chart/index.ts